import { render, staticRenderFns } from "./often-win.vue?vue&type=template&id=8162c6d6&scoped=true&"
import script from "./often-win.vue?vue&type=script&lang=js&"
export * from "./often-win.vue?vue&type=script&lang=js&"
import style0 from "./often-win.vue?vue&type=style&index=0&id=8162c6d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8162c6d6",
  null
  
)

export default component.exports